const UA = window.navigator.userAgent.toLowerCase();

export const isAndroid = UA && UA.indexOf('android') > 0;
export const isIOS = UA && /iphone|ipad|ipod|ios/.test(UA);

export function params(u, p) {
    var m = new RegExp('(?:&|/?)' + p + '=([^&$]+)').exec(u);
    return m ? m[1] : '';
}

// 获取链接
export function getQueryString(name) {
    var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
    var r = window.location.search.substr(1).match(reg);
    if (r != null) return unescape(r[2]);
    return null;
}

// 验证邮箱
export function isEmail(email) {
    return /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/.test(
        email
    );
}

// 验证电话
export function isMobile(mobile) {
    return /^1d{10}$/.test(mobile);
}

export function urlParser(a) {
    var c,
        d,
        e,
        f,
        g,
        h,
        i,
        j,
        k,
        b = '';
    for (
        a.indexOf('#') >= 0 &&
            ((b = a.substr(a.indexOf('#') + 1, a.length)),
            (a = a.replace('#' + b, ''))),
            c = '',
            a.indexOf('?') >= 0 &&
                ((c = a.substr(a.indexOf('?') + 1, a.length)),
                (a = a.replace('?' + c, ''))),
            d = a,
            e = c.split('&'),
            f = e.length,
            i = [],
            j = [],
            g = 0;
        f > g;
        g++
    )
        (h = e[g].split('=')), (i[h[0]] = h[1]);
    for (k = b.split('&'), f = k.length, g = 0; f > g; g++)
        (h = k[g].split('=')), (j[h[0]] = h[1]);
    return {
        data: function(a, b) {
            if ('undefined' == typeof b) {
                var c = i[a.toLowerCase()];
                return 'undefined' == typeof c ? '' : c;
            }
            i[a] = b;
        },
        hash: function(a, b) {
            if ('undefined' == typeof b) {
                var c = j[a.toLowerCase()];
                return 'undefined' == typeof c ? '' : c;
            }
            j[a] = b;
        },
        getHash: function() {
            var b,
                c,
                a = [];
            for (b in j) j[b] && a.push(b + '=' + j[b]);
            return (c = ''), a.length > 0 && (c = a.join('&')), c;
        },
        url: function() {
            var b,
                c,
                e,
                a = [];
            for (b in i) i[b] && a.push(b + '=' + i[b]);
            (c = ''), a.length > 0 && (c = '?' + a.join('&')), (a = []);
            for (b in j) j[b] && a.push(b + '=' + j[b]);
            return (
                (e = ''),
                a.length > 0 && (e = '#' + a.join('&')),
                d + '' + c + e
            );
        }
    };
}
